<form class="card-form" [formGroup]="form" (ngSubmit)="submit()">
  <mat-card>
    <mat-card-title i18n="title @@auth.login.title">
      Log in
    </mat-card-title>
    <mat-card-content>
      <p>
        <mat-form-field appearance="fill">
          <mat-label i18n="label @@form.email.label">Enter your email address</mat-label>
          <input type="email" matInput formControlName="email" tcAutofocus />
          <mat-error *tcMatFormFieldError i18n="error @@common.error.email.invalid">
            Enter a valid email address
          </mat-error>
        </mat-form-field>
      </p>

      <p *ngIf="showPasswordField">
        <mat-form-field appearance="fill">
          <mat-label i18n="label @@form.password.label">Enter your password</mat-label>
          <input type="password" matInput formControlName="password" />
          <mat-error *tcMatFormFieldError i18n="error @@common.error.password.required">
            Enter a password
          </mat-error>
        </mat-form-field>
      </p>

      <p *ngIf="errorMessage">
        <mat-error *ngIf="!unlockedDate && !showAttempts">{{ errorMessage }}</mat-error>
        <mat-error *ngIf="showAttempts">{{ errorMessage }}, you have {{attempts}} attempts left</mat-error>
        <mat-error *ngIf="!showAttempts && unlockedDate">All your attempts failed, you can try again at {{unlockedDate | date:'HH:mm:ss'}}</mat-error>
      </p>
    </mat-card-content>
    <mat-card-actions>
      <a mat-button color="primary" i18n="button @@auth.login.forgot" [routerLink]="['/login/forgot']">Forgot password?</a>
      <button type="submit" mat-raised-button color="primary" [disabled]="form.disabled">
        <ng-container *ngIf="showPasswordField; else emailContinue" i18n="@@auth.login.btn.login">LOG IN</ng-container>
        <ng-template #emailContinue i18n="@@auth.login.btn.continue">CONTINUE</ng-template>
      </button>
    </mat-card-actions>
  </mat-card>
</form>
